<template>
    <div class="hero" :class="classList">
        <navbar />
        <div class="inner container" v-if="variant === 'large'">
            <div class="row">
                <typewriter :text="['IT-Consulting', 'Web-Engineering', 'Raketentechnik']">
                <h1>
                    IT-Consulting
                    Web-Engineering
                    Raketen&shy;technik
                </h1>
                </typewriter>
                <div class="content">
                    <p><strong>Full-Stack-Entwicklung</strong> und<br> <strong>Technisches Projektmanagement</strong><br> aus Düsseldorf</p>
                </div>
            </div>
        </div>
        <activity class="stripe"></activity>
    </div>
</template>

<script>
import typewriter from './Typewriter'
import Navbar from './Navbar'
import Activity from './Activity';

export default {
    props: {
        variant: { type: String, default: "large"},
        watch: { type: Boolean, default: true}
    },
    components: {
        typewriter,
        Navbar,
        Activity
    },
    data() {
        return {
            scroll: 0,
            mounted: false
        }
    },
    mounted() {
        this.mounted = true;
        if (this.watch) {
            this.$root.$on('scroll', (scroll) => {
                this.scroll = scroll;
            });
        }
    },
    computed: {
        top() {
            if (!this.mounted) {
                return 0;
            }
            return 120;
            //return this.$el.getBoundingClientRect().height;
        },
        classList() {
            let list = [this.variant];

            if (this.watch && this.scroll > this.top) {
                list.push('invert');
                list.push('small');
            }
            return list;
        }
    }
}
</script>
